(function () {
    'user strict'

    angular
        .module('showcaseApp')
        .controller('ShowcaseSettingsController', ShowcaseSettingsController);

    function ShowcaseSettingsController(toastr, $state, $localStorage, $translate, $timeout, Constants,
                                    ModalFactory, StoreService, ShowcaseSettingsService) {

        var vm = this;

        var BRAND_VERTICAL = 'BRAND_VERTICAL';
        var BRAND_HORIZONTAL = 'BRAND_HORIZONTAL';
        var CATEGORY_VERTICAL = 'CATEGORY_VERTICAL';
        var CATEGORY_HORIZONTAL = 'CATEGORY_HORIZONTAL';

        vm.isMobile = detectar_mobile();
        vm.store = $localStorage.defaultStore;
        vm.showcaseSettings = undefined;
        vm.showDisplaySelectors = true;

        vm.brandDisplayOptions = [
            { id: 1, value: BRAND_VERTICAL, label: $translate.instant('settings.showcase.general.display.options.vertical') },
            { id: 2, value: BRAND_HORIZONTAL, label: $translate.instant('settings.showcase.general.display.options.horizontal') }
        ];

        vm.categoryDisplayOptions = [
            { id: 1, value: CATEGORY_VERTICAL, label: $translate.instant('settings.showcase.general.display.options.vertical') },
            { id: 2, value: CATEGORY_HORIZONTAL, label: $translate.instant('settings.showcase.general.display.options.horizontal') }
        ];

        init();

        function init() {
            loadSettigns();
        }

        function loadSettigns() {
            ShowcaseSettingsService.getByStoreId($localStorage.defaultStore.storeId).then(function (result) {
                if (result.data) {
                    vm.showcaseSettings = result.data;
                    applyDisplayDefaults();
                }
            })
        }

        // Filtros desabilitados chegam com orientação nula; pré-seleciona a vertical para o dropdown não ficar vazio.
        function applyDisplayDefaults() {
            if (!vm.showcaseSettings.brandFilterDisplay) {
                vm.showcaseSettings.brandFilterDisplay = BRAND_VERTICAL;
            }
            if (!vm.showcaseSettings.categoryFilterDisplay) {
                vm.showcaseSettings.categoryFilterDisplay = CATEGORY_VERTICAL;
            }
        }

        // O sort-dropdown só lê o value no $onInit; recria os componentes para refletir o estado salvo.
        function refreshDisplaySelectors() {
            vm.showDisplaySelectors = false;
            $timeout(function () {
                vm.showDisplaySelectors = true;
            });
        }

        vm.onBrandDisplayChange = function (newValue) {
            if (newValue) {
                vm.showcaseSettings.brandFilterDisplay = newValue.value;
            }
        }

        vm.onCategoryDisplayChange = function (newValue) {
            if (newValue) {
                vm.showcaseSettings.categoryFilterDisplay = newValue.value;
            }
        }

        function isBothHorizontalEnabled() {
            return vm.showcaseSettings.brandFilterEnabled &&
                vm.showcaseSettings.categoryFilterEnabled &&
                vm.showcaseSettings.brandFilterDisplay === BRAND_HORIZONTAL &&
                vm.showcaseSettings.categoryFilterDisplay === CATEGORY_HORIZONTAL;
        }

        vm.updateSettings = function() {
            if (isBothHorizontalEnabled()) {
                toastr.warning($translate.instant('settings.showcase.general.display.validation.both-horizontal'));
                return;
            }
            ModalFactory.openWarningModal(
                null,
                $translate.instant('settings.showcase.general.save-modal.title'),
                $translate.instant('settings.showcase.general.save-modal.small-text'),
                $translate.instant('settings.showcase.general.save-modal.warning-text'),
                $translate.instant('entity.action.continue'),
                $translate.instant('entity.action.cancel'),
                function () {
                    vm.isSaving = true;
                    ShowcaseSettingsService.update($localStorage.defaultStore.storeId, vm.showcaseSettings).then(function (result) {
                        vm.isSaving = false;
                        if (result.data) {
                            vm.showcaseSettings = result.data;
                            applyDisplayDefaults();
                            refreshDisplaySelectors();
                        }
                        toastr.success($translate.instant('settings.showcase.general.messages.success'));
                    }).catch(function (err) {
                        vm.isSaving = false;
                        if (err && err.headers && err.headers('statusKey') === 'showcaseSettingsBothHorizontal') {
                            toastr.warning($translate.instant('settings.showcase.general.display.validation.both-horizontal'));
                        } else {
                            toastr.error($translate.instant('settings.showcase.general.messages.error'));
                        }
                    });
                }
            );
        }
    }
})();
